import React, { useEffect, useState } from "react";
import * as cls from "./modalAnket.module.scss";

function Answers({
  handleAnswerSelectionMulty,
  currentQuestion,
  variants,
  index,
  handleAnswerSelection,
  selectedAnswerIndex,
  setCurrentQuestionId,
  comment,
  setComment,
  setIsNeedDetails,
  setNextQuestionId,
  setSelectedAnswerIndex,
  setAnswerId,
  showRequireFieldError,
  readonly,
}) {
  const {
    answer_text,
    next_question_id,
    is_need_details,
    question_id,
    answer_id,
    details,
    markAsAnswer,
    data_type_id,
    pattern,
    selected,
  } = variants;

  const [inputChecked, setInputChecked] = useState(false);
  const [inputChecked2, setInputChecked2] = useState(markAsAnswer || false);
  const [inputValue, setInputValue] = useState(details || "");

  const onchange = (e) => {
    if (readonly) return;
    const newValue = e.target.value;
    if (pattern) {
      const regexp = new RegExp(pattern);
      if (regexp.test(newValue) || newValue.length === 0) {
        setInputValue(newValue);
        setComment(newValue);
        setInputChecked2(newValue);
        handleAnswerSelectionMulty(
          index,
          next_question_id,
          answer_id,
          newValue
        );
      }
    } else {
      setInputValue(newValue);
      setComment(newValue);
    }
  };
  useEffect(() => {
    setCurrentQuestionId(question_id);
    setIsNeedDetails(is_need_details);

    if (markAsAnswer && selectedAnswerIndex === null) {
      setNextQuestionId(next_question_id);
      setAnswerId(answer_id);
    }
    if (is_need_details && comment === "") {
      setSelectedAnswerIndex(null);
    }
    if (selectedAnswerIndex !== null) {
      setInputChecked(selectedAnswerIndex === index);
    } else if (is_need_details && comment) {
      setInputChecked(true);
    } else if (is_need_details && !details && !comment) {
      setInputChecked(false);
    } else if (markAsAnswer) {
      setInputChecked(true);
      setNextQuestionId(next_question_id);
      setAnswerId(answer_id);
    } else {
      setInputChecked(false);
    }
  }, [variants, selectedAnswerIndex, comment]);
  if (currentQuestion.quetion_type_id === 3)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
        key={index}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <div>{answer_text}</div>
          {data_type_id === 1 && <span style={{ color: "red" }}>*</span>}
        </div>
        {is_need_details && (
          <>
            <input
              style={{ marginTop: "10px" }}
              value={inputValue}
              disabled={readonly}
              onChange={onchange}
              placeholder="Заполните поле"
            />
            <div style={{ color: "red", height: "1rem", fontSize: "0.75rem" }}>
              {data_type_id === 1 &&
                showRequireFieldError &&
                "   Заполните обязательное поле"}
            </div>
          </>
        )}
      </div>
    );
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        flexDirection: "column",
      }}
      key={index}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {currentQuestion.quetion_type_id === 1 ? (
          <input
            type="radio"
            checked={selected || inputChecked}
            className={cls.input}
            disabled={readonly}
            onChange={() => {
              if (readonly) return;
              handleAnswerSelection(index, next_question_id, answer_id);
            }}
          />
        ) : (
          <input
            checked={selected || inputChecked2}
            type="checkbox"
            className={cls.input}
            onChange={(e) => {
              if (readonly) return;
              setInputChecked2((prev) => !prev);
              handleAnswerSelectionMulty(
                index,
                next_question_id,
                answer_id,
                e.target.checked
              );
            }}
          />
        )}
        <div>{answer_text}</div>
      </div>

      {is_need_details && (
        <input
          value={selected || details}
          onChange={(e) => {
            if (readonly) return;
            setComment(e.target.value);
            handleAnswerSelection(index, next_question_id, answer_id);
          }}
          placeholder="Заполните поле"
        />
      )}
    </div>
  );
}

export default Answers;
